var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-telephone"},[_vm._v(" Tel: "+_vm._s(_vm.number)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }